export default "__VITE_ASSET__5b7f80ef__"